module.exports = __webpack_public_path__ + "static/media/ai-ad-talarico-thumbnailMOBILE.caee87d5.jpg";